import React, { useState } from 'react';
import {reactApi} from './../data/reactApi';
import Modal from './Modal';

const ReactComp = () => {

    const [reactData, setReactData] = useState(reactApi);

    const [modal, setModal] = useState(false);
    const [tempdata, setTempdata] = useState({});
    const modalBtn = (curr) => {
        setTempdata({...curr});
        return setModal(true);
    }
    
    return (
        <>
      <div className="container-fluid">
        <div className="row mt-5">
          <div className="col-lg-10 col-12 mx-auto">
            <div className="card-columns">
              {reactData.map((curr) => {
                return (
                  <>
                    <div className="card" key={curr.id}>
                      <div className="hovereffect">
                        <img
                          className="img-responsive card-img-top"
                          src={curr.img}
                          alt=""
                        />
                        <div className="overlay">
                          <button
                            className="overlyBtn"
                            onClick={() => modalBtn(curr)}
                          >
                            View Details
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>

            {modal === true ? (
              <Modal data={tempdata} hide={() => setModal(false)} />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
    );
};

export default ReactComp;